import { useState, useEffect } from 'react';
import { MaintenanceStatus, MaintenanceRecord } from '../../../../../types/api';

export const useMaintenanceRecordEditState = (selectedMaintenance: MaintenanceRecord | null, open: boolean) => {
  // Editing state - only for maintenance records
  const [editingMaintenanceId, setEditingMaintenanceId] = useState<string | null>(null);
  const [editingStatus, setEditingStatus] = useState<MaintenanceStatus | ''>('');
  const [editingStartDate, setEditingStartDate] = useState('');
  const [editingEndDate, setEditingEndDate] = useState('');
  const [editingContent, setEditingContent] = useState('');
  const [loading, setLoading] = useState(false);

  // Local state for immediate updates - only for maintenance
  const [localMaintenanceUpdates, setLocalMaintenanceUpdates] = useState<{[id: string]: Partial<MaintenanceRecord>}>({});

  // Clear local updates when dialog closes or selectedMaintenance changes
  useEffect(() => {
    if (!open) {
      setLocalMaintenanceUpdates({});
      setEditingMaintenanceId(null);
    }
  }, [open]);

  useEffect(() => {
    setLocalMaintenanceUpdates({});
    setEditingMaintenanceId(null);
  }, [selectedMaintenance]);

  // Get updated maintenance record with local changes applied
  const getDisplayMaintenance = () => {
    if (!selectedMaintenance) return null;
    const updates = localMaintenanceUpdates[selectedMaintenance.id];
    return updates ? { ...selectedMaintenance, ...updates } : selectedMaintenance;
  };

  const handleCancelEdit = () => {
    setEditingMaintenanceId(null);
    setEditingStatus('');
    setEditingStartDate('');
    setEditingEndDate('');
    setEditingContent('');
  };

  const handleEditMaintenance = (recordId: string, currentStartDate: string, currentEndDate: string, currentContent?: string) => {
    setEditingMaintenanceId(recordId);
    setEditingStartDate(currentStartDate);
    setEditingEndDate(currentEndDate);
    setEditingContent(currentContent || '');
  };

  return {
    // State - only maintenance-related
    editingMaintenanceId,
    editingStatus,
    editingStartDate,
    editingEndDate,
    editingContent,
    loading,
    localMaintenanceUpdates,

    // Setters
    setLoading,
    setLocalMaintenanceUpdates,
    setEditingStatus,
    setEditingStartDate,
    setEditingEndDate,
    setEditingContent,

    // Computed values
    displayMaintenance: getDisplayMaintenance(),

    // Actions
    handleCancelEdit,
    handleEditMaintenance,
  };
};
